// Storage Keys
export const ADMIN_VIEW_KEY = 'adminViewEnabled';
export const DEBUG_MODE_KEY = 'debugMode';
export const FAVORITE_WORKSPACES_KEY = 'sharpe-favorite-workspaces';
export const RESERVED_WORDS = ['create', 'new', 'add'];

export const SHARPE_HOMEPAGE_URL = 'https://sharpe.sh';
